/* eslint-disable @typescript-eslint/no-empty-function */
import { Divider, Paper, Stack, styled } from '@mui/material';
import { PresetsSummary } from './MachineGroupPresets';

type Params = {
  presetsSummary: PresetsSummary | undefined;
};

function PresetsInfo({ presetsSummary }: Params) {
  const total = presetsSummary?.total ?? 0;
  const unarchived = presetsSummary?.unarchived ?? 0;
  const archived = presetsSummary?.archived ?? 0;
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: 'black',
  }));

  return (
    <div style={{ paddingBottom: '2em' }}>
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={1.3}
      >
        <Item elevation={4}>Total: {total}</Item>
        <Item elevation={4}>Unarchived: {unarchived}</Item>
        <Item elevation={4}>Archived: {archived}</Item>
      </Stack>
    </div>
  );
}

export default PresetsInfo;
